/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class MergeSecuritiesGrid extends SiteEntityGrid<SecurityMergeRow, any> {
        protected getColumnsKey() { return 'Data.SecurityMerge'; }
        protected getDialogType() { return SecurityMergeDialog; }
        protected getIdProperty() { return SecurityMergeRow.idProperty; }
        protected getLocalTextPrefix() { return SecurityMergeRow.localTextPrefix; }
        protected getService() { return SecurityMergeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        protected getColumns() {
            return super.getColumns().filter(x => x.field != SecurityMergeRow.Fields.SecurityId);
        }

        protected getGridCanLoad() {
            return !!this._securityId;
        }

        protected addButtonClick() {
            if (!this.securityId)
                return;

            this.editItem(<SecurityMergeRow>{
                SecurityId: this.securityId
            });
        }

        private _securityId: number;

        public get securityId() {
            return this._securityId;
        }

        public set securityId(value: number) {
            if (this._securityId != value) {
                this._securityId = value;
                this.setEquality(SecurityMergeRow.Fields.SecurityId, value);
                this.refresh();
            }
        }
    }
}